var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 35,
    fill: "none",
    viewBox: "0 0 22 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.593 0v3.225c-9.696 2.418-11.548 15.884 3.029 17.569 2.034.232 3.188.871 3.668 1.307 1.358 1.242.624 4.888-3.56 4.888-1.713 0-3.18-.872-3.827-2.12H.185c.632 3.427 3.552 6.216 7.408 7.211V35h6.268v-2.912c8.708-1.7 12.34-15.23-2.2-17.12-2.95-.384-3.995-1.197-4.54-1.684-1.184-1.053-.566-4.96 3.617-4.96 2.303 0 4.176 1.583 4.176 3.522h6.508c0-4.06-3.181-7.496-7.56-8.621V0h-6.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.3b61e9e515c4eaf46dac638213837e0e.svg";
export { ForwardRef as ReactComponent };